import React, { useEffect, useRef, useState } from "react";
import Layout from "../pages/Layout";
import AddProductModal from "../components/AddProduct";
import AddStyleModal from "../components/AddStyle";
import HomeIcon from "../assets/icons/home_icon";
import DateIcon from "../assets/icons/calender_icon";
import EditIcon from "../images/edit_icon";
import DeleteIcon from "../images/delete_icon";
import MeasurementModal from "../components/Measurement";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import config from "../config";
import ClipLoader from "react-spinners/ClipLoader";
import DuplicateStyleModal from "../components/DuplicateStyle";
import { toast } from "react-toastify";

import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import { confirmAlert, successAlert, errorAlert } from "../utils/swal";
import enGB from "date-fns/locale/en-GB"; // British format
import { normalizeStyles } from "../utils/normalizeStyles";
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
registerLocale("en-GB", enGB);


const OrderPage = () => {
  const { order_id } = useParams();
  const [customer, setCustomer] = useState("");
  const [orderNo, setOrderNo] = useState("");
  const [orderDate, setOrderDate] = useState("");
  const [products, setProducts] = useState([]);
  const [orderStatus, setOrderStatus] = useState("");
  const [location, setLocation] = useState("");
  const [delivery_priority, setDeliveryPriority] = useState("")
  const [styleModalOpen, setStyleModalOpen] = useState(false);
  const [shippedDate, setShippedDate] = useState(null);
  const [quoteId, setQuoteId] = useState(null)

  const [selectedTeamMember, setSelectedTeamMember] = useState("");
  const [selectedStyle, setSelectedStyle] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [measurementModalOpen, setMeasurementModalOpen] = useState(false);
  const [totalPrice, setTotalPrice] = useState("");
  const [duplicate, setDuplicate] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState("");
  const [weddingDate, setWeddingDate] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false)
  const [newProduct, setNewProduct] = useState({
    style: "",
    quantity: 1,
    fabric: "",
    lining: "",
    groomsman: false,
    price: "",
    remarks: "",
    order_no: orderNo,
  });
  const [selectedImages, setSelectedImages] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(null);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [isQuoteCreated, setIsQuoteCreated] = useState(false);
  const [jacketMeasurements, setJacketMeasurements] = useState(null)
  const [currentCustomerId, setCurrentCustomerId] = useState(null)

  const [customerId, setCustomerId] = useState("");
  const [quote_id, setQuote_id] = useState("");

  const [productsInOrder, setProductsInOrder] = useState([]);
  const [duplicateStyleModalOpen, setDuplicateStyleModalOpen] = useState(false);
  const [styleToDuplicate, setStyleToDuplicate] = useState(null);
  const [discount, setDiscount] = useState(0)
  const navigate = useNavigate();

  const teamMemberRef = useRef(null);
  const locationRef = useRef(null);
  const priorityRef = useRef(null);
  const statusRef = useRef(null);



  const fetchProductStyles = async (productId) => {
    try {
      const res = await axios.get(`${config.BASE_URL}/api/v1/getProductStyles/${productId}`);
      const raw = res.data?.styles;

      const normalized = normalizeStyles(raw);
      // console.log("Normalized Styles:", normalized);

      return normalized;
    } catch (err) {
      console.error("Error fetching styles:", err);
      return [];
    }
  };

  useEffect(() => {
    if (isModalOpen || measurementModalOpen || styleModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen, measurementModalOpen, styleModalOpen]);



  useEffect(() => {
    // Reinitialize toasts after navigating back
    toast.dismiss(); // clear any stuck toasts
  }, []);

  const handleModalClose = () => {
    setIsModalOpen(false);
    setNewProduct({
      style: "",
      name: "",
      quantity: 1,
      fabric: "",
      lining: "",
      groomsman: false,
      price: "",
      remarks: "",
      order_no: orderNo,
      measurements: null,
    });
  };

  const handleDuplicateStyleOpen = (style) => {
    setStyleToDuplicate(style);
    setDuplicateStyleModalOpen(true);
  };

  const handleDuplicateStyleOpenWithDuplicate = async (productToDuplicate) => {
    // Agar aapka previous requirement specifically Suit ke components/measurements copy karna tha
    const parentSuit = products.find(p => p._id === productToDuplicate.parentSuitId);

    if (parentSuit && parentSuit.measurements) {
      setJacketMeasurements(parentSuit.measurements);
      setDuplicate(true);
      setSelectedStyle(productToDuplicate.description);
      setProductsInOrder(productToDuplicate._id);
      setCustomerId(productToDuplicate.customerInfo?._id || customer?._id);
      setMeasurementModalOpen(true);
    }

    // ✅ NAYA LOGIC: Database me naya product copy create karo
    const confirmDup = window.confirm("Do you want to create a duplicate of this product?");
    if (!confirmDup) return;

    try {
      const duplicatedData = { ...productToDuplicate };

      // Database IDs hata do
      delete duplicatedData._id;
      delete duplicatedData.createdAt;
      delete duplicatedData.updatedAt;
      delete duplicatedData.__v;

      // Aapne 'flatMap' se kuch temporary IDs ('123-jacket') banayi thi UI ke liye, usko handle karo
      if (duplicatedData.parentSuitId) delete duplicatedData.parentSuitId;
      if (duplicatedData.customerInfo) delete duplicatedData.customerInfo; // DB me sirf ID jati hai

      duplicatedData.order_id = order_id;
      duplicatedData.quote_id = null;
      duplicatedData.invoice_id = null;
      duplicatedData.customer_id = customerId || customer?._id;

      const response = await axios.post(
        `${config.BASE_URL}/api/v1/addProduct`,
        duplicatedData
      );

      if (response.status === 201 || response.status === 200) {
        toast.success("Product duplicated successfully!");
        setProducts((prev) => [...prev, response.data.product]);
      }
    } catch (error) {
      console.error("Error duplicating product:", error);
      toast.error("Failed to duplicate product.");
    }
  };

  const handleDuplicateStyleClose = () => {
    setDuplicateStyleModalOpen(false);
    setStyleToDuplicate(null);

    // setTimeout(() => {
    // window.location.reload();
    // }, 200);
  };

  const navigateToPreview = () => {
    navigate(`/order-preview/${order_id}`);
  };

  const productOptions = [
    { id: 1, style: "Suit" },
    { id: 2, style: "Jacket" },
    { id: 3, style: "Shirt" },
    { id: 4, style: "Pant" },
    { id: 5, style: "Tuxedo" },
    { id: 6, style: "Vest" },
    { id: 7, style: "Overcoat" },
    { id: 8, style: "Accessories" },
  ];
  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear().toString().slice(-4);
    return `${day}/${month}/${year}`;
  };

  const handleCustomerListClick = () => {
    navigate("/customers");
  };

  const handleSaveOrder = async () => {
    const priorityValue = priorityRef.current?.value || delivery_priority;
    const finalStatus = statusRef.current?.value || orderStatus;
    
    const orderData = {
      customer_id: customer?._id || customer,
      order_no: orderNo,
      delivery_date: deliveryDate,
      wedding_date: weddingDate,
      status: finalStatus,
      price: totalPrice,
      team_member: selectedTeamMember,
      location: location,
      delivery_priority: priorityValue,
      order_date: orderDate,
      quote_id: quoteId
    };

    try {
      const response = await axios.put(
        `${config.BASE_URL}/api/v1/updateOrder/${order_id}`,
        orderData
      );

      if (response.status === 200) {
        // const res = await axios.patch(`${config.BASE_URL}/api/v1/quote/update-discount/${response?.data?.data?.quote_id}`, { totalPrice, discount, weddingDate })
        toast.success("Order updated successfully!");
        // fetchOrdrDetails();
      } else {
        toast.error("Failed to update order. Please try again.");
      }
    } catch (error) {
      console.error("Error updating order:", error);
      toast.error(
        "An error occurred while updating the order. Please check the console for details."
      );
    }
  };


  const fetchOrdrDetails = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${config.BASE_URL}/api/v1/orderDetail/${order_id}`
      );

      const data = response?.data?.orderDetail;
      setCustomerId(data?.customer_id?._id)
      setQuoteId(data?.quote_id?._id)
      const productData = response?.data?.productDetail;
      // console.log(productData)
      setOrderNo(data?.order_no || "");
      setOrderStatus(data.status || "");
      setTotalPrice(data.price || 0);
      setDiscount(0)
      setDeliveryDate(data.delivery_date || "");
      setWeddingDate(data.wedding_date || "");
      setLocation(data.location || "");
      setDeliveryPriority(data.delivery_priority || "")
      setSelectedTeamMember(data.team_member || "");
      setCustomer(data.customer_id);
      setQuote_id(productData[0].quote_id);
      setOrderDate(data.order_date);

      // 🔁 Map product details with customer data if available
      const enrichedProducts = await Promise.all(
        productData.map(async (product) => {
          if (product.customer_id && typeof product.customer_id === "string") {
            // Fetch customer data
            try {
              const res = await axios.get(
                `${config.BASE_URL}/api/v1/detail/${product.customer_id}`
              );
              // console.log(res)

              return {
                ...product,
                customerInfo: res.data,
              };
            } catch (err) {
              console.error(`Failed to fetch customer ${product.customer_id}`);
              return { ...product };
            }
          }
          return {
            ...product,
            customerInfo: product.customer_id, // If already populated object
          };
        })
      );

      setProducts(enrichedProducts);
    } catch (error) {
      console.error("Error fetching quote details:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (order_id) {
      fetchOrdrDetails();
    }
  }, [order_id, isQuoteCreated]);

  const handleMeasurementModalClose = () => {
    setMeasurementModalOpen(false);
    setDuplicate(false);
  };

  const handleMeasurementModalOpen = (product) => {
    setSelectedStyle(product.description);
    setProductsInOrder(product._id);
    setCustomerId(product.customerInfo?._id || customer?._id); // Use specific customer if available
    setJacketMeasurements(null); // Ensure no jacket data is passed
    setMeasurementModalOpen(true);
  };



  const handleDeleteProduct = async (productId) => {
    const realId = String(productId);

    const confirmDelete = await confirmAlert({
      title: "Delete Product?",
      text: "Are you sure you want to delete this product? This action cannot be undone.",
      confirmText: "Yes, delete it",
      cancelText: "Cancel",
    });

    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `${config.BASE_URL}/api/v1/deleteProduct/${realId}`
      );

      if (response.status === 200) {
        toast.success("Product deleted successfully.");

        const updatedProductData = response?.data?.product;
        const fullyDeleted = response?.data?.fullyDeleted;

        if (!updatedProductData) {
          toast.error("Invalid delete response from server");
          return;
        }

        // ================= SUIT COMPONENT ONLY UPDATED =================
        if (!fullyDeleted && updatedProductData.description === "Suit") {
          setProducts((prevProducts) =>
            prevProducts.map((p) => {
              if (String(p._id) === String(updatedProductData._id)) {
                return {
                  ...p,
                  components: updatedProductData.components,
                };
              }
              return p;
            })
          );
        }

        // ================= FULL PRODUCT REMOVED =================
        else {
          setProducts((prevProducts) =>
            prevProducts.filter(
              (product) => String(product._id) !== String(updatedProductData._id)
            )
          );
        }
      } else {
        toast.error("Failed to delete the product. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("An error occurred while deleting the product.");
    }
  };



  const handleAddProductClick = () => {
    setIsModalOpen(true);
    setNewProduct((prev) => ({ order_no: orderNo }));
  };
  const handleEditProduct = async (product) => {
    // console.log('product', product)
    setNewProduct(product); // Modal me data set hoga jisme _id bhi hogi
    setIsModalOpen(true);
  };


  const handleStyleModalOpen = async (style, productId, customerId) => {

    setSelectedStyle(style?.value || style || "");

    setProductsInOrder(productId);

    setCurrentCustomerId(customerId)

    // Fetch and normalize styles
    // const normalized = await fetchProductStyles(productId);
    // console.log(normalized)
    // setSelectedStyle(normalized);

    setStyleModalOpen(true);
  };


  const handleStyleModalClose = () => {
    setStyleModalOpen(false);
    setSelectedStyle("");
  };

  const fileInputRefs = useRef({});

  const handleButtonClick = (productId) => {
    if (fileInputRefs.current[productId]) {
      fileInputRefs.current[productId].click();
    } else {
      console.log(`File input for product ${productId} is not available yet`);
    }
  };

  const handleImageChange = async (e, productId) => {
    const files = Array.from(e.target.files);
    setSelectedImages(files);

    const formData = new FormData();

    files.forEach((file) => {
      formData.append("images", file);
    });

    try {
      const response = await axios.put(
        `${config.BASE_URL}/api/v1/updateImages/${productId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(progress);
          },
        }
      );

      if (response.status === 200) {
        const updatedProductData = response.data.product;
        setProducts((prevProducts) =>
          prevProducts.map((p) => {

            if (p._id === updatedProductData._id) {
              if (p.description == "Suit") {
                return { ...p, components: updatedProductData.components };
              }
              return { ...p, images: updatedProductData.images };
            }
            return p;
          })
        );
        setUploadedImages(updatedProductData.images); // Keep this if you use it elsewhere
      }
      setUploadProgress(null);
    } catch (error) {
      console.error("Error updating product images:", error);
    }
  };

  // useEffect(() => {
  //   fetchOrdrDetails();
  // }, [uploadedImages]);

  // --- NEW FUNCTION FOR PLAN B ---
  const handleSendShippedEmail = async (product) => {
    // Check if the product has a customer and a valid email
    if (!product.customerInfo?.email) {
      toast.error(`Email address not found for customer: ${product.customerInfo?.customer_name || 'N/A'}`);
      return;
    }

    // Use Order level shippedDate 
    if (!shippedDate) {
      toast.error("Please select a Shipped Date first in the Order Details section.");
      return;
    }
    if (!location) {
      toast.error("Please select a Shipped Location first in the Order Details section.");
      return;
    }
    setButtonLoading(true)

    try {
      const response = await axios.post(`${config.BASE_URL}/api/v1/sendShippedEmail`, {
        orderNo: orderNo,
        customerEmail: product.customerInfo.email,
        customerName: product.customerInfo.customer_name,
        shippedDate: formatPureDate(shippedDate),
        location: location,
        productDescription: product.description
      });
      setButtonLoading(false)
      if (response.status === 200) {
        toast.success(`Shipped email sent successfully to ${product.customerInfo.customer_name}`);

      } else {
        toast.error("Failed to send shipped email.");
      }
    } catch (error) {
      setButtonLoading(false)
      console.error("Error sending shipped email:", error);
      toast.error("Error sending shipped email.");
    }
  };
  // --- END NEW FUNCTION ---

  // const handleRemoveImage = async (imageUrl, index, productId) => {
  //   // 1. Add a confirmation to prevent accidental deletes
  //   const confirmDelete = window.confirm("Are you sure you want to remove this image?");
  //   if (!confirmDelete) return;

  //   try {
  //     // 2. Use Axios instead of fetch for consistency
  //     // Note: In axios.delete, the body must be wrapped in a 'data' object
  //     const response = await axios.delete(
  //       `${config.BASE_URL}/api/v1/deleteImage/${productId}`,
  //       {
  //         data: { imageUrl: imageUrl }, // <--- Body goes here for DELETE requests
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       toast.success("Image removed successfully");

  //       // 3. Refresh the order details to show changes
  //       fetchOrdrDetails();
  //     } else {
  //       toast.error("Failed to delete the image");
  //     }
  //   } catch (error) {
  //     console.error("Error while deleting the image:", error);
  //     toast.error(error.response?.data?.message || "Error removing image");
  //   }
  // };

  const handleRemoveImage = async (imageUrl, index, productId) => {
    // 1. Add a confirmation to prevent accidental deletes
    const confirmDelete = await confirmAlert({
      title: "Remove Image?",
      text: "This image will be permanently removed from the product.",
      confirmText: "Yes, remove it",
      cancelText: "Cancel",
    });

    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `${config.BASE_URL}/api/v1/deleteImage/${productId}`,
        {
          data: { imageUrl: imageUrl }, // <--- Body goes here for DELETE requests
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Image removed successfully");

        // Get updated product data from backend response
        const updatedProductData = response.data.product;

        // Update local state immediately
        setProducts((prevProducts) =>
          prevProducts.map((p) => {
            // Check for matching ID
            if (p._id === updatedProductData._id) {
              // If it's a Suit, update the components object (where images live for suits)
              if (p.description === "Suit") {
                return { ...p, components: updatedProductData.components };
              }
              // For other products, update the main images array
              return { ...p, images: updatedProductData.images };
            }
            return p;
          })
        );
      } else {
        toast.error("Failed to delete the image");
      }
    } catch (error) {
      console.error("Error while deleting the image:", error);
      toast.error(error.response?.data?.message || "Error removing image");
    }
  };

  const displayProducts = products.flatMap(product => {

    if (product.description?.toLowerCase() === 'suit' && product.components) {

      return Object.entries(product.components)
        .filter(([key, component]) => component !== null) // Filter out any null components
        .map(([key, component]) => ({

          ...product,
          ...component,
          _id: `${product._id}-${key}`,
          parentSuitId: product._id,
          customerInfo: product.customerInfo || customer,
          customer_id: product.customer_id,
          quote_id: product.quote_id,
        }));
    }

    // For all other products (Shirt, Vest, etc.), return them as they are
    return [{
      ...product,
      customerInfo: product.customerInfo || customer
    }];
  });

  // console.log("products:", products);
  function formatPureDate(date) {
    if (!(date instanceof Date)) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // "2025-10-22"
  }


  return (
    <Layout>
      {isLoading ? (
        <div className="loader-container">
          <ClipLoader color="#123abc" size={80} />
        </div>
      ) : (
        <div className="order-page">
          <header className="header">
            <h1>Edit Order</h1>
            <p>
              <Link to="/" className="home-link">
                {" "}
                <HomeIcon />{" "}
              </Link>{" "}
              / Orders / Edit Order
            </p>
          </header>

          <div className="customer_details_new_order layout_outer_shadow">
            <div className="left">
              <div className="form-group row">
                <label className="field_label">Customer Name</label>
                <div className="field_value">{customer?.customer_name}</div>
              </div>
              <div className="form-group row">
                <label className="field_label">Order No</label>
                <div className="field_value">{orderNo}</div>
              </div>
              <div className="form-group row">
                <label className="field_label">Order Date</label>
                <div className="field_value">{formatDate(orderDate)}</div>
              </div>
              <div className="form-group row">
                <label className="field_label">Order Price</label>
                <div className="field_value">{totalPrice}</div>
              </div>

              {/* <div className="form-group row">
                <label htmlFor="teamMember" className="field_label">
                  Team Member
                </label>
                <div className="field_value">
                  <select
                    ref={teamMemberRef}
                    value={selectedTeamMember}
                    onChange={(e) => setSelectedTeamMember(e.target.value)}
                    onBlur={(e) => setSelectedTeamMember(e.target.value)} 
                    id="teamMember"
                    className="team-member-select"
                  >
                    <option value="" disabled>
                      Select Team Member
                    </option>
                    <option value="Ajay">Ajay</option>
                    <option value="Roshni">Roshni</option>
                    <option value="Ajay/indigo">Ajay/indigo</option>
                    <option value="Ajay/Raghav">Ajay/Raghav</option>
                    <option value="Roshni/indigo">Roshni/indigo</option>
                    <option value="Roshni/raghav">Roshni/raghav</option>
                    <option value="Indigo">Indigo</option>
                    <option value="Raghav">Raghav</option>
                    <option value="Raghav/indigo">Raghav/indigo</option>
                  </select>
                </div>
              </div> */}
              <div className="form-group row order_edit">
                <label className="field_label">Team Member</label>
                <div className="field_value">
                  <FormControl fullWidth size="small" >
                    <Select
                      id="teamMember"
                      value={selectedTeamMember}
                      onChange={(e) => setSelectedTeamMember(e.target.value)}
                      displayEmpty
                      sx={{ backgroundColor: '#fff' }}
                    >
                      <MenuItem value="" disabled>
                        Select Team Member
                      </MenuItem>
                      <MenuItem value="Ajay">Ajay</MenuItem>
                      <MenuItem value="Roshni">Roshni</MenuItem>
                      <MenuItem value="Ajay/indigo">Ajay/indigo</MenuItem>
                      <MenuItem value="Ajay/Raghav">Ajay/Raghav</MenuItem>
                      <MenuItem value="Roshni/indigo">Roshni/indigo</MenuItem>
                      <MenuItem value="Roshni/raghav">Roshni/raghav</MenuItem>
                      <MenuItem value="Indigo">Indigo</MenuItem>
                      <MenuItem value="Raghav">Raghav</MenuItem>
                      <MenuItem value="Raghav/indigo">Raghav/indigo</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>

            <div className="right">
              <div className="form-group row">
                <label htmlFor="deliveryDate" className="field_label">
                  <DateIcon />
                  Delivery Date
                </label>
                <div className="field_value">
                  <ReactDatePicker
                    selected={deliveryDate ? new Date(deliveryDate) : null}
                    onChange={(date) => setDeliveryDate(date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Select delivery date"
                    locale="en-GB"
                    calendarClassName="custom-datepicker-calendar"
                  />
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="weddingDate" className="field_label">
                  <DateIcon /> Wedding Date
                </label>
                <div className="field_value">
                  <ReactDatePicker
                    selected={weddingDate ? new Date(weddingDate) : null}
                    onChange={(date) => setWeddingDate(date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Select wedding date"
                    locale="en-GB"
                    calendarClassName="custom-datepicker-calendar"
                  />
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="orderStatus" className="field_label">Order Status</label>
                <div className="field_value">
                  <select
                    ref={statusRef}
                    id="orderStatus"
                    value={orderStatus}
                    onChange={(e) => setOrderStatus(e.target.value)}
                    onTouchEnd={(e) => setOrderStatus(e.target.value)}
                  >
                    <option value="To Place">To Place</option>
                    <option value="Production">Production</option>
                    <option value="Received">Received</option>
                    <option value="Delivered">Delivered</option>
                    <option value="Shipped">Shipped</option>
                  </select>
                </div>
              </div>


              {orderStatus === "Shipped" && (
                <div className="form-group row" style={{ marginTop: "10px" }}>
                  <label htmlFor="shippedDate" className="field_label"><DateIcon /> Shipped Date</label>
                  <div className="field_value">
                    <ReactDatePicker
                      id="shippedDate"
                      selected={shippedDate}
                      onChange={(date) => setShippedDate(date)}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Select shipped date"
                      className="date-picker"
                      locale="en-GB"
                    />
                    <button
                      className="btn shipmentbutton"
                      style={{ marginLeft: "10px", paddingLeft: "10px", paddingRight: "10px" }}
                      onClick={async () => {
                        if (!shippedDate) {
                          toast.error("Please select a shipped date first.");
                          return;
                        }
                        try {
                          const response = await axios.post(`${config.BASE_URL}/api/v1/sendShippedEmail`, {
                            orderNo,
                            customerEmail: customer.email,
                            customerName: customer.customer_name,
                            shippedDate: formatPureDate(shippedDate),
                            location
                          });
                          if (response.status === 200) {
                            toast.success("Shipped email sent successfully!");
                          } else {
                            toast.error("Failed to send shipped email.");
                          }
                        } catch (error) {
                          console.error(error);
                          toast.error("Error sending shipped email.");
                        }
                      }}
                    >
                      Send Email
                    </button>
                  </div>
                </div>
              )}


              {/* <div className="form-group row">
                <label for="location" className="field_label">
                  Location
                </label>
                <div className="field_value">
                  <select
                    ref={locationRef}
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    onBlur={(e) => setLocation(e.target.value)} // iPad fix
                  >
                    <option value="" disabled >
                      Select Location
                    </option>
                    <option value="Sydney CBD">Sydney CBD</option>
                    <option value="Castle Hill">Castle Hill</option>
                  </select>
                </div>
              </div> */}
              <div className="form-group row order_edit">
                <label htmlFor="location" className="field_label">Location</label>
                <div className="field_value">
                  <FormControl fullWidth  size="small">
                    <Select
                      value={location}
                      onChange={(e) => setLocation(e.target.value)}
                      displayEmpty
                      sx={{ backgroundColor: '#fff' }}
                    >
                      <MenuItem value="" disabled>
                        Select Location
                      </MenuItem>
                      <MenuItem value="Sydney CBD">Sydney CBD</MenuItem>
                      <MenuItem value="Castle Hill">Castle Hill</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>

              <div className="form-group row">
                <label for="location" className="field_label">
                  Delivery time
                </label>
                <div className="field_value">
                  <select
                    ref={priorityRef}
                    value={delivery_priority}
                    onChange={(e) => setDeliveryPriority(e.target.value)}
                    onBlur={(e) => setDeliveryPriority(e.target.value)} // iPad fix
                  >
                    <option value="" disabled>
                      Delivery time
                    </option>
                    <option value="Normal">Normal</option>
                    <option value="Urgent">Urgent</option>
                    <option value="Super urgent">Super Urgent</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="add_product_btn">
            <button
              className="add-product-btn btn"
              onClick={handleAddProductClick}
            >
              {" "}
              Add Product{" "}
            </button>
          </div>

          <div className="layout_outer_shadow_grid">
            {displayProducts.map((product) => (
              <div className="product_edit layout_outer_shadow">
                <div className="product_edit_item">
                  <h4 className="product_client_name">
                    {product.description} -{" "}
                    {product.customerName || product.customerInfo?.customer_name ||
                      customer?.customer_name}
                  </h4>
                  {product.description !== "Accessories" && <div className="add_style">
                    <button
                      className="add-product-btn btn"
                      onClick={() =>
                        handleStyleModalOpen(
                          product?.description,
                          product?._id,
                          product?.customerInfo?._id || product?.customer_id
                        )
                      }
                    >
                      Add Style{" "}
                    </button>
                  </div>}

                  {product.description !== "Accessories" && <div className="measurements">
                    <button
                      className="add-product-btn btn"
                      onClick={() => handleMeasurementModalOpen(product)}
                    >
                      {" "}
                      Measurements{" "}
                    </button>
                  </div>}



                  <div className="add_image">
                    <button
                      className="btn "
                      onClick={() => handleButtonClick(product._id)}
                    >
                      Add Image
                    </button>
                    <input
                      ref={(el) => (fileInputRefs.current[product._id] = el)}
                      type="file"
                      accept="image/*"
                      multiple
                      style={{ display: "none" }}
                      productId={product._id}
                      onChange={(e) => handleImageChange(e, product._id)}
                    />
                    {uploadProgress !== null && (
                      <div className="progress-bar">
                        <div
                          className="progress"
                          style={{ width: `${uploadProgress}%` }}
                        />
                      </div>
                    )}


                  </div>
                </div>
                <div className="product_edit_item">
                  <div className="form-group row">
                    <label for="qty" className="field_label">
                      Quantity
                    </label>
                    <div className="field_value">{product.quantity}</div>
                  </div>
                  <div className="form-group row">
                    <label for="fabric" className="field_label">
                      Fabric
                    </label>
                    <div className="field_value">{product.fabric}</div>
                  </div>
                  <div className="form-group row">
                    <label for="lining" className="field_label">
                      Lining
                    </label>
                    <div className="field_value">{product.lining}</div>
                  </div>
                </div>
                <div className="product_edit_item">
                  <div className="product_edit_remove_btns">
                    <button
                      className="edit_details"
                      onClick={(e) => {
                        e.preventDefault();
                        handleEditProduct(product);
                      }}
                    >
                      <EditIcon />
                    </button>
                    <button
                      className="remove_product"
                      onClick={() => handleDeleteProduct(product._id)}
                    >
                      <DeleteIcon />
                    </button>
                  </div>
                  <div className="m-b-20">
                    <label for="remarks">Remarks</label>
                    {/* <textarea id="remarks" readonly="" className="form-control">
                      {product.remarks}
                    </textarea> */}
                    <textarea
                      id="remarks"
                      readOnly
                      className="form-control"
                      value={product.remarks || ""}
                    />

                  </div>
                  <div className="row duplicateButton">
                    <div className="">
                      <button
                        className="btn"
                        onClick={() => handleDuplicateStyleOpen(product._id)}
                      >
                        Duplicate Style
                      </button>
                    </div>

                  </div>

                  {orderStatus === "Shipped" && product.description !== "Accessories" && (
                    <div style={{ marginTop: "10px" }}>
                      <button
                        className="btn bigShipmentButton"
                        disabled={buttonLoading}
                        style={{ backgroundColor: "#081042", color: "#fff", fontWeight: "400px", paddingLeft: '10px', paddingRight: '10px' }}
                        onClick={() => handleSendShippedEmail(product)}
                      >{buttonLoading ? (
                        <> <ClipLoader size={18} /> Sending... </>
                      ) : (`Email Shipment to ${product.customerInfo?.customer_name || 'Customer'}`)}</button>

                    </div>
                  )}



                  {/* {product.description?.toLowerCase() === "shirt" && (
                    <div className="row">
                      <div className="">
                        <button
                          className="btn"
                          onClick={() => handleDuplicateStyleOpenWithDuplicate(product)}
                        >
                          Shirt Measurement
                        </button>
                      </div>
                    </div>
                  )} */}
                </div>
                <div className="product_edit_item">
                  {product?.images?.length > 0 && (
                    <div className="uploaded-images">
                      <div className="image-previews">
                        {product?.images.map((imageUrl, index) => {
                          // Handle object with imagePath
                          const url =
                            typeof imageUrl === "object"
                              ? imageUrl?.imagePath
                              : imageUrl;

                          // If it's a Firebase URL, use it directly; else prefix with BASE_URL
                          const finalUrl = url?.startsWith("https://firebasestorage")
                            ? url
                            : `${config.BASE_URL}/${url}`;

                          return (
                            <div key={index} className="added_images">
                              <span
                                className="clos_btn"
                                style={{
                                  cursor: "pointer",
                                  userSelect: "none",
                                }}
                                onClick={() =>
                                  // If parentSuitId exists (it's a suit part), use that. Otherwise use _id.
                                  handleRemoveImage(url, index, product.parentSuitId || product._id)
                                }
                              >
                                -
                              </span>
                              <img
                                src={finalUrl}
                                alt={`Uploaded ${index}`}
                                width="100"
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          <DuplicateStyleModal
            isOpen={duplicateStyleModalOpen}
            onClose={handleDuplicateStyleClose}
            style={styleToDuplicate}
            onProductSaved={fetchOrdrDetails}
          />

          <AddProductModal
            isModalOpen={isModalOpen}
            newProduct={newProduct}
            setNewProduct={setNewProduct}
            handleModalClose={handleModalClose}
            quoteNo={orderNo}
            quote_id={quote_id}
            // handleSaveProduct={handleSaveProduct}
            setIsQuoteCreated={setIsQuoteCreated}
            isQuoteCreated={isQuoteCreated}
            productOptions={productOptions}
            isOrder={true}
            fetchQuoteDetails={fetchOrdrDetails}
            addOrderForSuit={true}
            customerId={customerId}
            customer_name={customer?.customer_name}
          />
          <AddStyleModal
            styleModalOpen={styleModalOpen}
            handleStyleModalClose={handleStyleModalClose}
            selectedStyle={selectedStyle}
            productsInOrder={productsInOrder}
            customerId={currentCustomerId}
            products={products}
            onMeasurementsUpdated={fetchOrdrDetails}
          />
          <MeasurementModal
            measurementModalOpen={measurementModalOpen}
            setNewProduct={setNewProduct}
            handleMeasurementModalClose={handleMeasurementModalClose}
            selectedStyle={selectedStyle}
            productsInOrder={productsInOrder}
            customerId={customerId}
            products={products}
            onMeasurementsUpdated={fetchOrdrDetails}
          />
          <div className="new_order_bottom_btns">
            <button className="btn" onClick={handleCustomerListClick}>
              Customer List
            </button>
            <button className="btn" onClick={handleSaveOrder}>
              Save Order
            </button>
            <button className="btn" onClick={navigateToPreview}>
              Preview
            </button>
            <button onClick={() => navigate(`/quotes/new-quote/${customer?._id}`)} className="btn">Back To Quote</button>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default OrderPage;
